import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconButton = _resolveComponent("IconButton")!
  const _component_Stunt = _resolveComponent("Stunt")!
  const _component_Card = _resolveComponent("Card")!
  const _component_AddNewAndEditStunt = _resolveComponent("AddNewAndEditStunt")!
  const _component_ModalWindow = _resolveComponent("ModalWindow")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Card, {
      title: _ctx.$t('stunts')
    }, {
      buttons: _withCtx(() => [
        _createVNode(_component_IconButton, {
          hint: _ctx.$t('add-new-stunt'),
          type: "PlusIcon",
          variant: "transparent",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.modal = true))
        }, null, 8, ["hint"])
      ]),
      content: _withCtx(() => [
        _createElementVNode("ul", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.characters[_ctx.current].stunts, (stunt, index) => {
            return (_openBlock(), _createElementBlock("li", {
              key: stunt.name
            }, [
              _createVNode(_component_Stunt, {
                stunt: stunt,
                onRemove: () => _ctx.remove(index),
                onUpdate: (newStunt) => _ctx.update(newStunt, index)
              }, null, 8, ["stunt", "onRemove", "onUpdate"])
            ]))
          }), 128))
        ])
      ]),
      _: 1
    }, 8, ["title"]),
    _createVNode(_component_ModalWindow, {
      modelValue: _ctx.modal,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.modal) = $event)),
      title: _ctx.$t('add-new-stunt')
    }, {
      default: _withCtx(() => [
        _createVNode(_component_AddNewAndEditStunt, {
          stunt: { name: '', description: '', skill: undefined },
          mode: "new",
          onUpdate: _ctx.add,
          onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.modal = false))
        }, null, 8, ["onUpdate"])
      ]),
      _: 1
    }, 8, ["modelValue", "title"])
  ], 64))
}